import React, { useState, useEffect } from 'react';
import './Clock.scss'

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formattedTime = time.toLocaleTimeString();

  return (
    <div className='frame-clock'>
      <span>{formattedTime}</span>
    </div>
  );
}

export default Clock;
